import { combineKindSubKind } from 'utils/timeslot-key'
import _ from "lodash";
import ObjectBooking from "utils/objects/booking";
import ObjectLunchOption from "utils/objects/lunch-option";
import { bookingConstants } from "utils/constants/booking-constants";
import ObjectTimeslot from "utils/objects/timeslot";

const HelperTimeslot = {
	
	create: ( { building = {}, floor = {}, room = {}, day = {}} = {} ) => {
		const timeslotsBooking = [];
		const timeslotsTransport = [];
		const timeslotsLunch = [];
		
		let disabledBooking = false;
		let disabledTransport = false;
		let disabledLunch = false;
		
		if( !_.isEmpty( day ) ) {
			_.forEach( _.get( day, 'slots', [] ), timeslot => {
				const kind = timeslot?.kind;

				const buildingParkingSpace = _.get( timeslot, 'building_parking_space', {} );
				
				// Get the capacity
				const capacityBooking = {
					is_timeslot: true,
					timeslot: timeslot,
					building: building,
					floor: floor,
					room: room,
					building_parking_space: buildingParkingSpace
				};
				
				const capacityObjects = ObjectBooking.removeKeyUntil(
					capacityBooking,
					timeslot.timeslot_by
				);
				
				// Create the booking object
				let booking = {
					booking_date: day.bookingDate,
					capacity: 0,
					kind: kind,
					transport_kind: _.get( timeslot, 'transport_kind', null ),
					building_parking_space: buildingParkingSpace,
					...capacityObjects
				};

				switch ( kind ) {
					case bookingConstants.LUNCH:
						// Set occupied
						booking[ 'available_lunch_options' ] = ObjectLunchOption.getOptions( {
							building: building,
							floor: floor,
						} );
						
						timeslotsLunch.push( booking );
						break;
					
					case bookingConstants.TRANSPORT:
						timeslotsTransport.push( booking );
						break;
						
					default:
						timeslotsBooking.push( booking );
						break;
				}
			} );
		}
		
		return {
			timeslotsBooking: timeslotsBooking,
			timeslotsLunch: timeslotsLunch,
			timeslotsTransport: timeslotsTransport,
			
			disabledBooking: disabledBooking,
			disabledLunch: disabledLunch,
			disabledTransport: disabledTransport
		};
	},
	
	createFlat: ( { building = {}, floor = {}, room = {}, day = {} } = {} ) => {
		const list = HelperTimeslot.create({ building, floor, room, day });

		const result = [];
		_.forEach( list, ( timeslots, name ) => {
			if( _.startsWith( name, 'timeslots') ) {
				_.forEach( timeslots, timeslot => {

					const timeslotCapacity = ObjectTimeslot.getCapacity( timeslot );
					if( timeslotCapacity?.exception_kind === 'hidden' ) {
						return true;;
					}
					
					// Check for the disabled field
					_.forEach( list, ( timeslots2, name2 ) => {
						if( _.startsWith( name2, 'disabled') ) {
							const testName = _.replace( name2, 'disabled', '' );
							
							if( _.includes( name, testName ) ) {
								timeslot['disabled'] = timeslots2;
							}
						}
					});
					
					result.push( timeslot );
				})
			}
		});
		
		return result;
	},
	
	combineKindSubKind,

}

export default HelperTimeslot
